<template>
  <div class="coach-home">
    <div class="submissions-app learners-list" :class="{'open':showFilter, 'closed': !showFilter}">
      <div
        ref="sidebar-facets"
        class="sidebar-left"
        :class="{'open':showFilter, 'closed': !showFilter}"
        v-show="$mq == 'large' || $mq == 'xlarge'"
      >
        <div class="facets-data">
          <div class="search-bar">
            <div class="title">
              <h1>My Learners</h1>
            </div>
            <md-field class="search">
              <label>Search</label>
              <md-icon>search</md-icon>
              <md-input
                @keyup="searchBarTyping = true"
                @keyup.enter="searchBarTyping = false; goSearch()"
                v-model="searchBar"
              ></md-input>
              <md-button
                v-show="searchBarTyping == true"
                @click="searchBarTyping = searchBar == '' ? true : false; goSearch()"
                class="md-button search"
              >
                Search
                <md-icon>arrow_right_alt</md-icon>
              </md-button>
              <md-button
                v-show="searchBarTyping == false"
                @click="searchBarTyping = true; searchBar = ''; clearSearchResult()"
                class="md-icon-button clear"
              >
                <md-icon class="clear">close</md-icon>
              </md-button>
            </md-field>
            <md-button @click="toogleSidebar()" class="filter">
              <md-icon>filter_list</md-icon>
              <span>Filter</span>
              <md-icon class="close" :class="{'active':showFilter}">close</md-icon>
            </md-button>
          </div>
          <div class="other-filters" :class="{'open':showFilter, 'closed': !showFilter}">
            <div class="filters">
              <div class="data" :key="index" v-for="(facet, index) in facets_ordered">
                <div
                  class="facet-wrapper"
                  :key="field"
                  v-for="(item, field) in facet"
                  :class="{'collapsed':collapsed[field]}"
                >
                  <a @click="toggleFilterItem(field)">
                    {{ decorateFacetLabels(field) }}
                    <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more' }}</md-icon>
                  </a>
                  <div class="facet" :class="field" v-show="collapsed[field]">
                    <md-checkbox
                      :ref="field + '_' + index"
                      :key="index"
                      v-for="(data, index) in item"
                      @change="updateData(data.url)"
                      v-model="data.values.active"
                      :value="data.values.value"
                    >{{ transformValue(field, data.values.value) }}
                    </md-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="actions">
              <md-button class="clear" v-on:click="clearSearchResult">Reset</md-button>
              <md-button class="md-raised apply" v-on:click="applySearch">Apply</md-button>
            </div>
          </div>
        </div>
      </div>
      <div class="results_count">
        <div class="count">{{ result_count }} Learner{{ result_count > 1 ? 's' : '' }}</div>
        <div class="breadcrumbs">
          <div :key="index" v-for="(facet, index) in facets">
            <div class="breadcrumbs-group" :key="field" v-for="(item, field) in facet">
              <div :key="index" v-for="(data, index) in item">
                <div v-if="data.values.active" class="breadcrumb">
                  <span>{{ transformValue(field, data.values.value) }}</span>
                  <md-button class="md-icon-button" @click="removeFacetsAction(data)">
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </div>
            </div>
          </div>
          <md-button
            v-if="breadcrumbs.length"
            class="clear"
            v-on:click="clearSearchResult"
          >Clear all
          </md-button>
        </div>
      </div>
      <div class="result">

        <div class="mobile" v-if="$mq != 'large' && $mq != 'xlarge'">
          <div class="row" :key="i" v-for="(item, i) in filtered" :data-uuid="item.uuid">
            <div class="data-wrapper">
              <div :key="key" v-for="(name, key) in columns" :class="key">
              <span v-if="key === 'learner' && item[key] != ''">
                <span class="title">Learner: </span>
                <a :href="learnerLink(filtered[i].uid)"><span v-html="item[key]"></span></a>
              </span>
                <span v-else-if="key === 'learner_group' && item[key] != ''">
                <span class="title">Group: </span><span v-html="item[key]"></span>
              </span>
                <span v-else-if="key === 'role' && item[key] != ''">
                <span class="title">Role: </span><span v-html="item[key]"></span>
              </span>
                <span v-else-if="key === 'learning_path' && item[key] != ''">
                <span class="title">Learning Path:</span><span v-html="item[key]"></span>
              </span>
                <span v-else-if="key === 'lp_completion' && item[key] != ''">
                <span v-if="item.learning_path === ''"><span class="title">Learning Path Completion: </span> N/A</span>
                <span v-else><span class="title">Learning Path Completion:</span>{{ item[key] }}%</span>
              </span>
                <span v-else-if="key === 'assignment_completion' && item[key] != ''">
                <span v-if="item.assignment_completion === 'N/A'"><span class="title">{{ assignmentLabel }} Completion: </span>N/A</span>
                <span v-else><span class="title">{{ assignmentLabel }} Completion:</span>{{ item[key] }}%</span>
              </span>
                <span v-else-if="key === 'submission_user_last_time' && item[key] != ''">
                <span class="title">Last Access: </span><span>{{ item[key] }}</span>
              </span>
                <span v-else v-html="item[key]"></span>
              </div>
            </div>
            <div class="view-more">
              <a :href="learnerLink(filtered[i].uid)">View More</a>
            </div>
          </div>
        </div>

        <div class="table" v-else>
          <div class="header">
            <div v-for="(name, key) in columns" :class="key" :key="key">
              <span v-if="key == 'id'">{{ name }}</span>
              <a v-else @click="toggleSort(key)" :class="{'active':sorted[key]}">
                {{ name }}
                <md-icon
                  v-if="key !== 'uuid' "
                >{{ sorted[key] === 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down' }}
                </md-icon>
              </a>
            </div>
          </div>
          <div class="row" :key="i" v-for="(item, i) in filtered" :data-uuid="item.uuid">
            <div class="data">
              <div :key="key" v-for="(name, key) in columns" :class="key">
              <span v-if="key === 'learner'">
                <a :href="learnerLink(filtered[i].uid)">{{ item[key] }}</a>
              </span>
                <span v-else-if="key === 'lp_completion'">
                <span v-if="item.learning_path === ''">N/A</span>
                <span v-else>{{ item[key] }}%</span>
              </span>
                <span v-else-if="key === 'assignment_completion'">
                <span v-if="item.assignment_completion === 'N/A'">N/A</span>
                <span v-else>{{ item[key] }}%</span>
              </span>

                <span v-else v-html="item[key]"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <paginate
        v-if="pager.total_pages > 1"
        :page-count="pager.total_pages"
        :click-handler="pagerAction"
        :prev-text="''"
        :prev-class="'prev'"
        :next-text="''"
        :next-class="'next'"
        :container-class="'pagination'"
      ></paginate>
      <spinner v-if="showLoader"></spinner>
    </div>
  </div>
</template>

<script>
import Spinner from "./components/Spinner.vue";
import Vue from "vue";
import Paginate from "vuejs-paginate";
import Submissions from "./Submissions";

export default {
  name: "CoachHome",
  mixins: [Submissions],

  components: {
    Spinner,
    Paginate,
  },
  computed: {
    facets_ordered() {
      var ordering = {}, // map for efficient lookup of sortIndex
        sortOrder = ["learner_group", "role", "learning_path"];
      for (var i = 0; i < sortOrder.length; i++) {
        ordering[sortOrder[i]] = i;
      }
      return this.facets.sort((a, b) => {
        return (
          ordering[Object.keys(a)[0]] - ordering[Object.keys(b)[0]] ||
          Object.keys(a)[0].localeCompare(Object.keys(b)[0])
        );
      });
    },
  },
  data() {
    let cols = window.drupalSettings.controller.submissions_settings.columns;
    let sorted = {};
    let keys = Object.keys(cols);
    for (let i = 0; i < keys.length; i++) {
      sorted[keys[i]] = 0;
    }
    return {
      collapsed: {},
      lastUrl: "/rest/learners",
      facets: [],
      activeFacets: {},
      pager: [],
      currentPage: 1,
      searchBar: "",
      searchBarTyping: true,
      filtered: [],
      columns: cols,
      sorted: sorted,
      showLoader: false,
      showFilter: false,
      small: false,
      activeItem: false,
      assignmentLabel: window.drupalSettings.group_catch_config.labels.assignment_label || "Assignment",
    };
  },
  watch: {},

  methods: {
    log(msg) {
      console.log(msg);
    },

    learnerLink(uid) {
      return "/learner/" + uid;
    },

    decorateFacetLabels(field) {
      if (field === "learning_path") {
        return "Learning Path";
      }
      if (field === "learner_group") {
        return "Group";
      }
      if (field === "role") {
        return "Role";
      }
      return field;
    },

    clearSearchResult() {
      this.searchBar = "";
      this.searchBarTyping = true;
      this.lastUrl = "/rest/learners";
      this.fetchInitialData();
      this.toogleSidebar(0);
    },

    decorateData(data) {
      for (let key in data) {
        let item = data[key];

        item.date = this.$moment.utc(item.date).local().format("MM/DD/YYYY");
        if (item.time) {
          item.date =
            item.date +
            " " +
            this.$moment.utc(item.time).local().format("h:mm A");
        }
      }
      return data;
    },

    fetchInitialData() {
      this.showLoader = true;
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      fetch("/rest/learners", options)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.filtered = data.search_results ? this.decorateData(data.search_results) : [];
        this.pager = data.pager ? data.pager : [];
        this.facets = this.decorateFacets(data.facets);
        this.showLoader = false;
      })
      .catch(() => {
        this.showLoader = false;
      });
    },

    updateData(url) {
      this.showLoader = true;
      this.lastUrl = url;
      fetch(url)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.filtered = data.search_results ? this.decorateData(data.search_results) : [];
        this.pager = data.pager ? data.pager : [];
        this.facets = this.decorateFacets(data.facets);
        this.showLoader = false;
        this.currentPage = this.pager.current_page + 1;
      })
      .catch(() => {
        this.showLoader = false;
      });
    },

    getUrlByParams(params) {
      let arr = [];
      for (let [k, v] of Object.entries(params)) {
        if (v) {
          // Sort order must be uppercase
          if (k === "sort_order") {
            v = v.toUpperCase();
          }
          arr.push(k + "=" + v);
        }
      }
      return "/rest/learners?" + arr.join("&");
    },

    transformValue(field, val) {
      return val;
    },
  },
};
</script>
<style lang="scss">
.page-coach {
  @media all and (max-width: $breakpoint-medium) {
    .fb-welcome {
      box-shadow: none;
    }
    .upscroll .submissions-app .search-bar {
      max-height: initial;
    }
    .downscroll .submissions-app {
      &.closed {
        margin-top: 0;
      }
      .sidebar-left.open .search-bar {
        max-height: initial;
        margin-top: 40px;
      }
    }
  }
}
.submissions-app.learners-list {
  .sidebar-left.open {
    position: absolute;

    .title h1 {
      color: $white;
    }
  }

  .search-bar {
    margin-bottom: 20px;

    .title {
      min-width: 215px;

      &:before {
        content: "";
        position: absolute;
        display: block;
        width: 80px;
        background: url("assets/learners_icon.svg");
        height: 80px;
        background-position: top center;
        background-repeat: no-repeat;
      }

      h1 {
        font-size: 20px;
        margin-left: 95px;
      }
    }

    .search {
      margin-left: 50px;
    }
  }

  @media all and (max-width: $breakpoint-medium) {
    margin-top: 80px;

    .sidebar-left.open {
      position: fixed;
      .search-bar {
        margin-bottom: 0;
      }
    }

    .search-bar {
      display: block;
      margin-top: 55px;
      max-height: initial;

      .title {
        &:before {
          content: none;
        }
        h1 {
          color: $white;
          line-height: 32px;
          margin-left: 0;
        }
      }

      .search {
        margin-left: 0;
        margin-bottom: 0;
        display: inline-flex;
        width: calc(100% - 61px);
        &.md-field .md-button.search {
          display: block;
          margin-left: 0;
          max-width: 110px;
        }
      }

      .filter {
        margin: 0;
        .md-ripple {
          padding: 8px;
          .md-button-content {
            color: $white;
            .md-icon {
              color: $white;
            }
          }
        }
      }
    }
  }

  .result {
    border-radius: 20px;
    background: #ffffff;
    padding: 0px !important;
    font-family: "Source Sans Pro" !important;
    overflow: hidden;

    > div {
      width: 100%;
    }
  }

  .header {
    display: flex;
    font-family: "filson-soft", sans-serif;
    text-transform: uppercase;
    padding: 20px;
    border-bottom: 1px solid rgb(224, 224, 224);

    > div {
      padding-left: 1%;
      padding-right: 1%;
      width: 17%;
      background: transparent !important;
    }

    a {
      display: flex;
      color: rgb(60, 60, 60) !important;
      font-weight: normal !important;
      i {
        font-size: 20px !important;
      }
      &:hover {
        text-decoration: none !important;
        cursor: pointer;
      }
    }
  }

  .row {
    border-bottom: 1px solid rgb(224, 224, 224);

    &.active {
      margin-top: 0px;
      margin-left: 0px;
      margin-bottom: 0px;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
      border-left: 6px solid $blue-dark;
    }

    &.grey {
      background: rgb(245, 245, 245);
    }

    .data {
      display: flex;
      align-items: center;
      padding: 10px;
      > div {
        padding-left: 1%;
        padding-right: 1%;
        width: 17%;
        background: transparent !important;
      }

      .learner {
        a {
          color: $blue-active !important;
          text-transform: capitalize;
        }
      }
    }
  }
}
</style>
